export default __webpack_public_path__ + "static/media/otra-vida-tattoo_piercing.de30e193.webp";